'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'circle-dollar';
var width = 512;
var height = 512;
var aliases = ["dollar-circle","usd-circle"];
var unicode = 'f2e8';
var svgPathData = 'M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-408c13.3 0 24 10.7 24 24l0 16 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-61.6 0c-10.2 0-18.4 8.2-18.4 18.4 0 9.2 6.8 17 16 18.2l54.4 7.2c33 4.4 57.7 32.5 57.7 65.8 0 35.9-28.4 65.1-64 66.3l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l77.6 0c10.2 0 18.4-8.2 18.4-18.4 0-9.2-6.8-17-16-18.2l-54.4-7.2c-33-4.4-57.7-32.5-57.7-65.8 0-35.9 28.4-65.1 64-66.3l0-16c0-13.3 10.7-24 24-24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleDollar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;